import logo from "./logo.svg";
import "./App.css";
import RouterHandler from "./RouterHandler";

function App() {
  return (
    <div className="App">
      <RouterHandler />
    </div>
  );
}

export default App;
